import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as ngxbootstrap from 'ngx-bootstrap';


@NgModule({
  imports: [
    CommonModule,
    ngxbootstrap.DatepickerModule.forRoot(),
    ngxbootstrap.PaginationModule.forRoot()
  ]
})
export class NgxBootstrapModule { }
